import { useEffect, useState } from 'react'
import { useGetApiBookingGroupsVisitGroupId } from '@barbershop/api/customer'

const POLLING_DURATION_MS = 30_000
const POLLING_INTERVAL_MS = 2000

export const useBookingGroup = (branchId: number, visitGroupId: string) => {
    const [deadline, setDeadline] = useState(() => Date.now() + POLLING_DURATION_MS)
    const [isPollingExhausted, setIsPollingExhausted] = useState(false)
    const query = useGetApiBookingGroupsVisitGroupId(
        visitGroupId,
        { branch_id: branchId },
        {
            query: {
                retry: false,
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchInterval: ({ state }) =>
                    state.data?.status === 'awaiting_payment' &&
                    state.error == null &&
                    Date.now() < deadline
                        ? POLLING_INTERVAL_MS
                        : false,
            },
        }
    )

    useEffect(() => {
        const timer = globalThis.setTimeout(
            () => setIsPollingExhausted(true),
            Math.max(0, deadline - Date.now())
        )

        return () => globalThis.clearTimeout(timer)
    }, [deadline])

    const checkAgain = () => {
        setIsPollingExhausted(false)
        setDeadline(Date.now() + POLLING_DURATION_MS)

        return query.refetch({ cancelRefetch: false })
    }

    return { ...query, isPollingExhausted, checkAgain }
}
